export function BuildPipelineOverviewStats(props: {
  inProgress: number;
  finalQa: number;
  buildComplete: number;
  onBoard: number;
  onInventoryRequest: () => void;
}) {
  return (
    <div className="flex flex-wrap items-stretch gap-3">
      <OverviewStat label="In progress" value={props.inProgress} />
      <OverviewStat label="Final QA" value={props.finalQa} />
      <OverviewStat label="Build complete" value={props.buildComplete} />
      <OverviewStat label="On board" value={props.onBoard} />
      <button
        type="button"
        onClick={props.onInventoryRequest}
        className="ml-auto min-w-[7.5rem] rounded-xl border border-gray-200 bg-white px-4 py-2 text-left hover:border-indigo-300 hover:bg-indigo-50 dark:border-zinc-700 dark:bg-zinc-900 dark:hover:border-indigo-500/50 dark:hover:bg-indigo-950/40"
        title="Request materials without leaving the board"
      >
        <div className="font-mono text-2xl font-bold text-indigo-700 dark:text-indigo-300">+</div>
        <div className="text-[11px] font-medium text-gray-500 dark:text-zinc-400">
          Inventory request
        </div>
      </button>
    </div>
  );
}

function OverviewStat({ label, value }: { label: string; value: number }) {
  return (
    <div className="min-w-[7.5rem] rounded-xl border border-gray-200 bg-white px-4 py-2 dark:border-zinc-700 dark:bg-zinc-900">
      <div className="font-mono text-2xl font-bold text-gray-900 dark:text-zinc-50">{value}</div>
      <div className="text-[11px] font-medium text-gray-500 dark:text-zinc-400">{label}</div>
    </div>
  );
}
